//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.missingField
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.StartInspectionMutation
import com.wintermar.inspection.graphql.type.InspectionStatus
import com.wintermar.inspection.graphql.type.adapter.InspectionStatus_ResponseAdapter
import kotlin.String
import kotlin.collections.List

public object StartInspectionMutation_ResponseAdapter {
  public object Data : Adapter<StartInspectionMutation.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("startInspection")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): StartInspectionMutation.Data {
      var _startInspection: StartInspectionMutation.StartInspection? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _startInspection = StartInspection.obj().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return StartInspectionMutation.Data(
        startInspection = _startInspection ?: missingField(reader, "startInspection")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: StartInspectionMutation.Data,
    ) {
      writer.name("startInspection")
      StartInspection.obj().toJson(writer, customScalarAdapters, value.startInspection)
    }
  }

  public object StartInspection : Adapter<StartInspectionMutation.StartInspection> {
    public val RESPONSE_NAMES: List<String> = listOf("status")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): StartInspectionMutation.StartInspection {
      var _status: InspectionStatus? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _status = InspectionStatus_ResponseAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return StartInspectionMutation.StartInspection(
        status = _status ?: missingField(reader, "status")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: StartInspectionMutation.StartInspection,
    ) {
      writer.name("status")
      InspectionStatus_ResponseAdapter.toJson(writer, customScalarAdapters, value.status)
    }
  }
}
